import { render, staticRenderFns } from "./TenderAutomationEvents.vue?vue&type=template&id=dd801544&scoped=true"
import script from "./TenderAutomationEvents.vue?vue&type=script&lang=js"
export * from "./TenderAutomationEvents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd801544",
  null
  
)

export default component.exports